import { render, staticRenderFns } from "./EmailNotificationIcon.vue?vue&type=template&id=33f10ece&"
import script from "./EmailNotificationIcon.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports